import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=056ccd48&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=js"
export * from "./sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056ccd48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056ccd48')) {
      api.createRecord('056ccd48', component.options)
    } else {
      api.reload('056ccd48', component.options)
    }
    module.hot.accept("./sidebar.vue?vue&type=template&id=056ccd48&scoped=true", function () {
      api.rerender('056ccd48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/sidebar.vue"
export default component.exports